module.exports = __webpack_public_path__ + "static/media/watermark-selection.d6701994.png";